export default __webpack_public_path__ + "static/media/share_fb_pt.dfafad0e.gif";